import { getObject, LocalStorageKeys, setObject } from 'utils/storage'

interface OnboardingData {
  password_updated?: boolean
  goal?: string
  other_health_goal?: string
  coaching_kinds?: ('nutrition' | 'stress' | 'fitness')[]
  selected_coach_id?: string
  call_scheduled?: boolean
  call_scheduling_completed?: boolean
  insurance_plan?: string
  other_insurance_plan?: string
}

export const getOnboardingData = (): OnboardingData | null => {
  return getObject<OnboardingData>(LocalStorageKeys.OnboardingData)
}

export const setOnboardingData = (onboardingData: Partial<OnboardingData>) => {
  const currentOnboardingData = getOnboardingData()

  setObject(LocalStorageKeys.OnboardingData, { ...currentOnboardingData, ...onboardingData })
}
